<ng-container *transloco="let t; read: 'profile'">
  <!-- Toast notifications configuration -->
  <p-toast position="bottom-center"></p-toast>

  <div class="container-fluid user-profile">
    <div class="row flex flex-wrap">
      <div class="col-lg-4">
        <app-my-user-profile-editor></app-my-user-profile-editor>
      </div>
      <div class="col-lg-8 user-profile__hours-and-calls-wrapper">
        <p-card>
          <app-hours-and-calls></app-hours-and-calls>
        </p-card>
      </div>
    </div>
    <div class="row flex flex-wrap py-2">
      <div class="col-lg-12">
        <app-referral></app-referral>
      </div>
    </div>
    <div class="row flex flex-wrap py-1">
      <div class="col-lg-12">
        <app-confirmed-events-table></app-confirmed-events-table>
      </div>
    </div>
    <div class="row flex flex-wrap py-1">
      <div class="col-lg-12">
        <p-card class="p-card-content--no-padding">
          <ng-template pTemplate="header">
            <legend class="flex flex-wrap p-3 pb-0">{{ t('reminders') }}</legend>
          </ng-template>
          <app-message-template-subscribe></app-message-template-subscribe>
        </p-card>
      </div>
    </div>
  </div>
</ng-container>
